const MILLISECONDS_PER_SECOND = 1000;

export const getSecondsLeft = (until: number, now: number): number =>
  Math.max(0, Math.ceil((until - now) / MILLISECONDS_PER_SECOND));
